/**
 * Styles pages: arrow buttons and sub-category chips for the horizontal design rows.
 */
class HomStyles extends HTMLElement {
  #ac = new AbortController();

  connectedCallback() {
    const { signal } = this.#ac;
    this.addEventListener('click', this.#onClick, { signal });
    this.#applyGender(this.#storedGender());
    for (const row of this.querySelectorAll('[data-row]')) {
      row.addEventListener('scroll', () => this.#sync(row), { signal, passive: true });
      this.#sync(row);
    }
  }

  disconnectedCallback() {
    this.#ac.abort();
  }

  #reduced() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /** @param {Event} e */
  #onClick = (e) => {
    const t = e.target instanceof Element ? e.target : null;
    const arrow = t?.closest('[data-scroll]');
    const g = t?.closest('[data-gender]');
    if (g instanceof HTMLElement && g.closest('.gfilter')) {
      this.#applyGender(g.dataset.gender ?? 'all');
      try {
        localStorage.setItem('hom_gender', g.dataset.gender ?? 'all');
      } catch {
        // storage may be unavailable
      }
      return;
    }
    const chip = t?.closest('[data-jump]');
    const section = (arrow ?? chip)?.closest('.colrow');
    const row = section?.querySelector('[data-row]');
    if (!(row instanceof HTMLElement)) return;
    const behavior = this.#reduced() ? 'auto' : 'smooth';

    if (arrow instanceof HTMLElement) {
      row.scrollBy({ left: Number(arrow.dataset.scroll) * row.clientWidth * 0.85, behavior });
    }
    if (chip instanceof HTMLElement) {
      const first = row.querySelector(`[data-sub="${chip.dataset.jump}"]`);
      if (first instanceof HTMLElement) row.scrollTo({ left: first.offsetLeft - row.offsetLeft, behavior });
      for (const c of section.querySelectorAll('[data-jump]')) c.setAttribute('aria-pressed', String(c === chip));
    }
  };

  /** @param {HTMLElement} row */
  #sync(row) {
    const section = row.closest('.colrow');
    if (!section) return;
    const [prev, next] = section.querySelectorAll('[data-scroll]');
    if (prev instanceof HTMLButtonElement) prev.disabled = row.scrollLeft < 4;
    if (next instanceof HTMLButtonElement) next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
  }

  /** Women / Men / All: unisex designs (u) stay visible for every choice. */
  #storedGender() {
    if (!this.querySelector('.gfilter')) return 'all';   // filter hidden (2026-10-18): never keep designs hidden by an old choice
    try {
      return localStorage.getItem('hom_gender') ?? 'all';
    } catch {
      return 'all';
    }
  }

  /** @param {string} g */
  #applyGender(g) {
    for (const b of this.querySelectorAll('.gfilter [data-gender]')) b.setAttribute('aria-pressed', String(b.getAttribute('data-gender') === g));
    for (const c of this.querySelectorAll('.dcard[data-gender]')) {
      const cg = c.getAttribute('data-gender') || 'u';
      c.hidden = !(g === 'all' || cg === 'u' || cg === g);
    }
    this.dataset.gender = g;
  }
}

if (!customElements.get('hom-styles')) customElements.define('hom-styles', HomStyles);
